"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOTAL_TAB_NUM = exports.SERVICE_ID_REG = exports.HTTP_TIMEOUT = exports.METRIC_USE_FREQUENCY = exports.METRIC_BROWSER_INFO = exports.METRIC_PAGE_TIME = exports.METRIC_COUNTER_TYPE = exports.METRIC_GAUGE_TYPE = exports.METRIC = exports.STUCK_TIMES_MAX = exports.FPS_STUCK_VALUE = exports.FPS_SAMPLE_TIME = exports.PREFIX_HEARTBEAT_KEY = exports.HEARTBEAT_INTERVAL = exports.SENTRY_CONFIG = exports.REPORT_MAX_COUNT = exports.REPORT_DELAY = exports.ROOT_TABLE = exports.ROOT = exports.DEV_SERVER_URL = exports.SERVER_URL = void 0;
var SERVER_URL = 'https://kelper-log.56qq.com';
exports.SERVER_URL = SERVER_URL;
var DEV_SERVER_URL = 'https://kepler-server.dev-ag.56qq.com';
exports.DEV_SERVER_URL = DEV_SERVER_URL;
var ROOT = 'root';
exports.ROOT = ROOT;
var ROOT_TABLE = 'kepler_root_table'; // 上报延迟

exports.ROOT_TABLE = ROOT_TABLE;
var REPORT_DELAY = 5000; // 上报条数限制

exports.REPORT_DELAY = REPORT_DELAY;
var REPORT_MAX_COUNT = 10; // const { data, ...others } = params
// 缓存上报的sentry配置数据即others
// 因为初始化时要上报缓存的数据 需要使用到这些个配置数据

exports.REPORT_MAX_COUNT = REPORT_MAX_COUNT;
var SENTRY_CONFIG = 'kepler_sentry_config'; // 检测崩溃心跳间隔

exports.SENTRY_CONFIG = SENTRY_CONFIG;
var HEARTBEAT_INTERVAL = 5 * 1000; // 存储在本地用于识别心跳key前缀

exports.HEARTBEAT_INTERVAL = HEARTBEAT_INTERVAL;
var PREFIX_HEARTBEAT_KEY = 'kepler_heartbeat_'; // fps抽样间隔

exports.PREFIX_HEARTBEAT_KEY = PREFIX_HEARTBEAT_KEY;
var FPS_SAMPLE_TIME = 60 * 1000; // fps小于20即为流畅度有问题

exports.FPS_SAMPLE_TIME = FPS_SAMPLE_TIME;
var FPS_STUCK_VALUE = 20; // fps连续3次小于20即卡顿

exports.FPS_STUCK_VALUE = FPS_STUCK_VALUE;
var STUCK_TIMES_MAX = 3;
exports.STUCK_TIMES_MAX = STUCK_TIMES_MAX;
var METRIC = 'metric';
exports.METRIC = METRIC;
var METRIC_GAUGE_TYPE = 'Gauge';
exports.METRIC_GAUGE_TYPE = METRIC_GAUGE_TYPE;
var METRIC_COUNTER_TYPE = 'Counter'; // 统计 页面时间

exports.METRIC_COUNTER_TYPE = METRIC_COUNTER_TYPE;
var METRIC_PAGE_TIME = 'web_page_time'; // 统计 客户端信息

exports.METRIC_PAGE_TIME = METRIC_PAGE_TIME;
var METRIC_BROWSER_INFO = 'web_browser_info'; // 统计 使用频度

exports.METRIC_BROWSER_INFO = METRIC_BROWSER_INFO;
var METRIC_USE_FREQUENCY = 'web_use_frequency'; // http超时设置

exports.METRIC_USE_FREQUENCY = METRIC_USE_FREQUENCY;
var HTTP_TIMEOUT = 3 * 1000; // serviceId传入格式限制

exports.HTTP_TIMEOUT = HTTP_TIMEOUT;
var SERVICE_ID_REG = /^web-(.*?)-.*$/; // 同时打开页面的tab数

exports.SERVICE_ID_REG = SERVICE_ID_REG;
var TOTAL_TAB_NUM = 'kepler_total_tab';
exports.TOTAL_TAB_NUM = TOTAL_TAB_NUM;